export const COLORS = {
  black: '#000000',
  white: '#ffffff',
  plum: '#9A4C95',
  lightGray: '#E3E3E3',
};
